// Croatian labele koraka wizarda za unos vozila — jedini izvor labela, dijele
// ih settings kartica i vehicle wizard. Ključevi moraju odgovarati backend
// katalogu (VehicleWizardStepCatalog).
export const VEHICLE_WIZARD_STEP_LABELS: Record<string, string> = {
  picker: "Vozilo",
  info: "Info",
  tires: "Gume",
  location: "Lokacija",
  equipment: "Oprema",
  extinguisher: "PP aparat",
  owner: "Vlasnik",
  price: "Cijena",
  pictures: "Slike",
  documents: "Dokumenti",
};
